import Request from './request'
const baseURL = '/dataone-api/api/v1/'
let instance = new Request(baseURL)
export default instance;

let instance_v2 = new Request('/data-api-v2/')
export const DataAPI_V2 = instance_v2;